import React from "react";
import { CardHeader } from "../Header";
import CardCount from "../CardCount/CardCount";
import DashboardChart from "./DashboardChart";
import { CentersFilter, CenterSitesFilter, DateFilter } from "../Filters";
import { Button } from "../Button";
import language from "../../language";
import { connect } from "react-redux";
import { Loading } from "../Loader";
import { Select } from "../Input";

const ReusableDashboard = ({
  filtersConfig,
  onFind,
  cardGroups = [],
  charts = [],
  loading = false,
  defaultLanguage,
  emptyMessage = "No data available",
}) => {
  const filters = filtersConfig.filters || {};

  const handleChange = (key, value) => {
    if (key === "periodType" && !value) {
      filtersConfig.onFilterChange(key, {
        value: "weekday",
        label: "Week day",
      });
    } else {
      filtersConfig.onFilterChange(key, value);
    }
  };

  const handleFind = () => {
    onFind();
  };

  return (
    <div className="container-fluid" style={{ minHeight: "600px" }}>
      {/* Filters */}
      <div className="card p-4 mb-4 shadow-sm rounded">
        <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          {(filtersConfig.customFilter || []).map((item, index) => (
            <Select
              key={index}
              options={item.options}
              placeholder={item.label}
              value={filters[item.keyFilter]}
              onChange={(e) => handleChange(item.keyFilter, e)}
              disabled={loading}
            />
          ))}
          <CentersFilter
            handleApplyFilters={(isLoading, value) =>
              handleChange("centers", value?.centers)
            }
            disabled={loading}
          />
          <CenterSitesFilter
            filters={filters}
            handleApplyFilters={(isLoading, value) =>
              handleChange("centerSites", value?.centerSites)
            }
            disabled={loading}
          />
          <DateFilter
            startDate={filters.startDate}
            endDate={filters.endDate}
            handleApplyFilters={(isLoading, value) =>
              handleChange("date-range", value)
            }
            disabled={loading}
          />

          <Button
            text={language[defaultLanguage].load_data}
            disabled={loading}
            onPress={handleFind}
          />
        </div>
      </div>

      {loading ? (
        <center>
          <Loading />
        </center>
      ) : (
        <>
          {/* Cards */}
          {cardGroups.map((group, index) => (
            <div key={index} className="mb-4">
              {group.title && <CardHeader title={group.title} />}
              <div className="row mt-2">
                {group.isLoading && (
                  <div className={`col-md-12 mb-3`}>
                    <center>
                      <Loading />
                    </center>
                  </div>
                )}
                {!group.isLoading &&
                  group.items.map((card, idx) => (
                    <div
                      className={`col-6 col-md-${group.col || "3"} mb-3`}
                      key={idx}
                    >
                      <CardCount {...card} color={group.color} />
                    </div>
                  ))}
                {!group.isLoading && !(group.items || []).length && (
                  <div className="p-5 text-center text-muted">
                    {group.emptyMessage || "No data available"}
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* Charts */}
          <div className="row">
            {charts.map((chart, idx) => (
              <div key={chart.id || idx} className={`col-12 col-md-${chart.col || 6}`}>
                <div className="card p-4 mb-4 shadow-sm rounded">
                  {chart.isLoading ? (
                    <center>
                      <Loading />
                    </center>
                  ) : (
                    <DashboardChart {...chart} />
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* No file provided */}
          {!cardGroups.length && !charts.length && !loading && (
            <div className="border p-5 text-center text-muted">
              {emptyMessage}
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ReusableDashboard);
